module.exports = __webpack_public_path__ + "static/media/Hover2.3157d53d.svg";